export enum OverlayOrientationEnum {
  Top = 0,
  Middle = 1,
  Bottom = 2,
  Custom = 3,
}

export type OverlayOrientation =
  | OverlayOrientationEnum.Top
  | OverlayOrientationEnum.Middle
  | OverlayOrientationEnum.Bottom
  | OverlayOrientationEnum.Custom;
